import React from "react";
export const CommandBarPlaceHolder = ({ commandBarHeight })=>{
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            height: commandBarHeight
        }
    });
};
